import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import withMaintenanceCheck from "../src/Component/Maintenance/WithMaintaineceCheck"

import App from "./App/index";
import * as serviceWorker from "./serviceWorker";
import config from "./config";
import { PersistGate } from "redux-persist/integration/react";
import storeConfig from "./store/index";
const { store, persistor } = storeConfig;

const AppWithMaintenance = withMaintenanceCheck(App);
const app = (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter basename={config.basename}>
        {/* <App /> */}
        <AppWithMaintenance />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
